export class Patient {
  constructor() {
    this.id = 0
    this.fname = ''
    this.lname = ''
    this.email = ''
    this.age = 0
    this.gender = 'M'
    this.phone = ''
    this.birthdate = null
    this.cpf = ''
    this.rg = ''
    this.observations = ''
  }

  static FromObj(obj) {
    const instance = new Patient()
    
    instance.id = obj.id || 0
    instance.fname = obj.fname || ''
    instance.lname = obj.lname || ''
    instance.email = obj.email || ''
    instance.age = obj.age || 0
    instance.gender = obj.gender || 'M'
    instance.phone = obj.phone || ''
    instance.birthdate = obj.birthdate || null
    instance.cpf = obj.cpf || ''
    instance.rg = obj.rg || ''
    instance.observations = obj.observations || ''
    
    return instance
  }

  // Métodos de formatação
  getDisplayName() {
    return `${this.fname} ${this.lname}`.trim()
  }

  getInitials() {
    const firstName = this.fname?.charAt(0) || ''
    const lastName = this.lname?.charAt(0) || ''
    return `${firstName}${lastName}`.toUpperCase()
  }

  getAgeDisplay() {
    if (this.age > 0) {
      return `${this.age} anos`
    }
    
    if (this.birthdate) {
      const today = new Date()
      const birthDate = new Date(this.birthdate)
      const age = today.getFullYear() - birthDate.getFullYear()
      const monthDiff = today.getMonth() - birthDate.getMonth()
      
      if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birthDate.getDate())) {
        return `${age - 1} anos`
      }
      return `${age} anos`
    }
    
    return 'Idade não informada'
  }

  getGenderDisplay() {
    return this.gender === 'M' ? 'Masculino' : 'Feminino'
  }

  getGenderIcon() {
    return this.gender === 'M' ? 'male' : 'female'
  }

  // Validações
  isValid() {
    return this.fname.length > 0 && this.lname.length > 0
  }

  isEmailValid() {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
    return emailRegex.test(this.email)
  }

  isPhoneValid() {
    const phoneRegex = /^\+?[\d\s\-\(\)]+$/
    return phoneRegex.test(this.phone)
  }

  isCpfValid() {
    if (!this.cpf) return true // CPF é opcional
    
    const cpf = this.cpf.replace(/\D/g, '')
    
    if (cpf.length !== 11) return false
    
    // Verifica se todos os dígitos são iguais
    if (/^(\d)\1{10}$/.test(cpf)) return false
    
    // Validação do CPF
    let sum = 0
    let remainder
    
    for (let i = 1; i <= 9; i++) {
      sum += parseInt(cpf.substring(i - 1, i)) * (11 - i)
    }
    
    remainder = (sum * 10) % 11
    
    if (remainder === 10 || remainder === 11) remainder = 0
    
    if (remainder !== parseInt(cpf.substring(9, 10))) return false
    
    sum = 0
    for (let i = 1; i <= 10; i++) {
      sum += parseInt(cpf.substring(i - 1, i)) * (12 - i)
    }
    
    remainder = (sum * 10) % 11
    
    if (remainder === 10 || remainder === 11) remainder = 0
    
    if (remainder !== parseInt(cpf.substring(10, 11))) return false
    
    return true
  }

  // Formatação de dados
  getFormattedCpf() {
    if (!this.cpf) return ''
    
    const cpf = this.cpf.replace(/\D/g, '')
    
    if (cpf.length === 11) {
      return cpf.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4')
    }
    
    return this.cpf
  }

  getFormattedPhone() {
    if (!this.phone) return ''
    
    const phone = this.phone.replace(/\D/g, '')
    
    if (phone.length === 11) {
      return phone.replace(/(\d{2})(\d{5})(\d{4})/, '($1) $2-$3')
    } else if (phone.length === 10) {
      return phone.replace(/(\d{2})(\d{4})(\d{4})/, '($1) $2-$3')
    }
    
    return this.phone
  }

  getFormattedBirthdate() {
    if (!this.birthdate) return ''
    
    const date = new Date(this.birthdate)
    return date.toLocaleDateString('pt-BR')
  }

  // Métodos utilitários
  calculateAge() {
    if (!this.birthdate) return this.age
    
    const today = new Date()
    const birthDate = new Date(this.birthdate)
    let age = today.getFullYear() - birthDate.getFullYear()
    const monthDiff = today.getMonth() - birthDate.getMonth()
    
    if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birthDate.getDate())) {
      age--
    }
    
    return age
  }

  // Dados para formulário
  toFormData() {
    return {
      id: this.id,
      fname: this.fname,
      lname: this.lname,
      email: this.email,
      age: this.age,
      gender: this.gender,
      phone: this.phone,
      birthdate: this.birthdate,
      cpf: this.cpf,
      rg: this.rg,
      observations: this.observations
    }
  }

  // Atualizar dados
  updateFromFormData(formData) {
    this.fname = formData.fname || this.fname
    this.lname = formData.lname || this.lname
    this.email = formData.email || this.email
    this.age = formData.age || this.age
    this.gender = formData.gender || this.gender
    this.phone = formData.phone || this.phone
    this.birthdate = formData.birthdate || this.birthdate
    this.cpf = formData.cpf || this.cpf
    this.rg = formData.rg || this.rg
    this.observations = formData.observations || this.observations
  }
}